import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../../Redux/common/action";
import { URL } from "../../Redux/common/url";
import { Link, useParams } from "react-router-dom";
import TruncateText from "../TruncateText/TruncateText";
import HomeSlider from "../Home/HomeSlider";
import CategorySlider from "../Home/CategorySlider";
import { Card, Row, Col, Typography, Tag, Rate } from "antd";
import {
  ShopOutlined,
  GoldOutlined,
  TagOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";

const { Text, Title } = Typography;
function SubCategoryProductAndCategory() {
  const get_category_Filter = useSelector((state) =>
    state?.allapi?.get_category_Filter ? state?.allapi?.get_category_Filter : []
  );

  const get_product_list = useSelector((state) =>
    state?.allapi?.get_seller_product_list_public_by_cate
      ? state?.allapi?.get_seller_product_list_public_by_cate
      : {}
  );
  const [childcateee, setchildcateee] = useState("");
  console.log(get_category_Filter);
  const { id } = useParams();
  const dispatch = useDispatch();
  const henldetofilterbyCate = (e) => {
    // if (search) {
    //   dispatch(
    //     allapiAction.userSearchProduct({ page: pageno, id: search, cateId: e })
    //   );
    // }
  };

  useEffect(() => {
    dispatch(allapiAction.getsubcategryListbymainCategory({ id: id }));
    dispatch(allapiAction.getsliderList({ page: "subCategoryPage" }));
    dispatch(
      allapiAction.getsellerProductListbycategoryNew({ page: 1, id: id })
    );

    return () => {};
  }, []);

  const [windowWidth, setWindowWidth] = useState(600);

  // Update window width when the window is resized
  useLayoutEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div>
      {" "}
      <div class="row p-7 ps-layout--shop ">
        <div class="col-md-3 mobile_hide">
          <div class="ps-layout__left">
            <aside class="widget widget_shop">
              <h4 class="widget-title">Categories</h4>
              <ul class="ps-list--categories">
                {get_category_Filter &&
                  get_category_Filter?.map((data, i) => {
                    return (
                      <li class="menu-item-has-children" key={i}>
                        <a href="#">{data?.name}</a>
                        <span
                          class={
                            childcateee == data?._id
                              ? "sub-toggle active "
                              : "sub-toggle"
                          }
                          onClick={() => {
                            setchildcateee(data?._id);
                          }}
                        >
                          <i class="fa fa-angle-down"></i>
                        </span>
                        <ul
                          class="sub-menu"
                          style={
                            childcateee == data?._id
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >
                          {data?.subcates &&
                            data?.subcates?.map((datachild, index) => {
                              return (
                                <li key={index}>
                                  <a
                                    href="#"
                                    onClick={() => {
                                      henldetofilterbyCate(datachild?._id);
                                    }}
                                  >
                                    {datachild?.name}
                                  </a>
                                </li>
                              );
                            })}
                        </ul>
                      </li>
                    );
                  })}
              </ul>
            </aside>
          </div>
        </div>
        <div class="col-md-9 col-12">
          <div id="other-data">
            <div class="row p-10">
              <div class="col-md-12 col-12 p-8">
                <div className="hometest">
                  <CategorySlider />
                </div>
              </div>
              <div class="col-md-12 col-12 shop_by_cat mb-10">
                <h3 class="text-center text-white p-4">
                  <b>Tob global brands</b>
                </h3>
              </div>

              {get_category_Filter &&
                get_category_Filter?.map((data, i) => {
                  return (
                    i < 6 && (
                      <div class="col-2 col-md-2 mb-4 mt-2" key={i}>
                        <Link
                          to={"/sub-sub-category/" + data?.slug}
                          className="all_categoryimagetest"
                        >
                          <img
                            src={URL?.API_BASE_URL + data?.image}
                            alt="Category 1"
                            class="all_category-image"
                          />
                        </Link>
                        <h6 class="text-center mt-5">
                          <b>{data?.name}</b>
                        </h6>
                      </div>
                    )
                  );
                })}
                {get_category_Filter &&
                get_category_Filter?.map((data, i) => {
                  return (
                    i > 5 &&
                    i < 12 && (
                      <div class="col-2 col-md-2 mb-4 mt-2" key={i}>
                        <Link
                          to={"/sub-sub-category/" + data?.slug}
                          className="all_categoryimagetest"
                        >
                          <img
                            src={URL?.API_BASE_URL + data?.image}
                            alt="Category 1"
                            class="all_category-image"
                          />
                        </Link>
                        <h6 class="text-center mt-5">
                          <b>{data?.name}</b>
                        </h6>
                      </div>
                    )
                  );
                })}
              <div class="col-md-12 col-12 p-8"></div>

              {/* {get_product_list?.docs &&
                get_product_list?.docs?.map((data, i) => {
                  return (
                    i < 8 && (
                      <div class="col-md-3 col-4 p-8" key={i}>
                        <div class="card subcategcard_back">
                          <Link to={"/product/" + data?.pro_sulg}>
                            <img
                              src={URL?.API_BASE_URL + data?.featureImage}
                              class="sub_cat_product_image"
                            />
                          </Link>
                          <h6 class="text-center bg-white">
                            {" "}
                            <TruncateText
                              text={data?.title}
                              maxLength={windowWidth > 600 ? 25 : 15}
                            />
                          </h6>
                        </div>
                      </div>
                    )
                  );
                })} */}

                 <div className="ps-section__content mt-10">
                  <Row gutter={[16, 16]}>
                    {get_product_list?.docs &&
                      get_product_list?.docs?.map((data, i) => {
                        // --- 1. Price Calculation Logic (Existing) ---
                        const productprice =
                          data?.productType === "Gram"
                            ? data.categoryId?.rate * data?.size + data?.price
                            : data?.price;

                        // --- 2. Type Detection Logic ---
                        const isGramItem = data?.productType === "Gram";

                        // --- 3. URL Logic ---
                        const productUrl =
                          data?.typeof === "Listing"
                            ? "/listing/" + data?.pro_sulg
                            : "/product/" + data?.pro_sulg;

                        return (
                          // Responsive Grid: Mobile(2 items), Tablet(3 items), Desktop(4 items)
                          <Col xs={12} sm={8} md={6} lg={6} key={i}>
                            <Link to={productUrl}>
                              <Card
                                hoverable
                                style={{
                                  width: "100%",
                                  borderRadius: "12px",
                                  overflow: "hidden",
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                                }}
                                bodyStyle={{ padding: "12px" }} // Compact padding
                                cover={
                                  <div
                                    style={{
                                      position: "relative",
                                      height: "200px",
                                      overflow: "hidden",
                                    }}
                                  >
                                    {/* --- Product Image --- */}
                                    {/* <CoustomImg
                                      url={
                                        URL.API_BASE_URL + data?.featureImage
                                      }
                                      altkey={data?.title}
                                      w1={200}
                                      w2={300}
                                      h1={200}
                                      h2={300}
                                    /> */}
                                    <img
                                      alt={data?.title}
                                      src={
                                        URL.API_BASE_URL + data?.featureImage
                                      }
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        transition: "transform 0.3s",
                                      }}
                                      onMouseOver={(e) =>
                                        (e.currentTarget.style.transform =
                                          "scale(1.05)")
                                      }
                                      onMouseOut={(e) =>
                                        (e.currentTarget.style.transform =
                                          "scale(1)")
                                      }
                                    />

                                    {/* --- SMART TAG (Top Right) --- */}
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: 8,
                                        right: 8,
                                      }}
                                    >
                                      {isGramItem ? (
                                        <Tag
                                          color="#d48806"
                                          style={{ margin: 0, fontWeight: 600 }}
                                        >
                                          <GoldOutlined /> Per Gram
                                        </Tag>
                                      ) : (
                                        <Tag
                                          color="#108ee9"
                                          style={{ margin: 0, fontWeight: 600 }}
                                        >
                                          <TagOutlined /> Fixed
                                        </Tag>
                                      )}
                                    </div>
                                  </div>
                                }
                              >
                                {/* --- Card Content --- */}

                                {/* 1. Title */}
                                <div
                                  style={{
                                    height: "44px",
                                    overflow: "hidden",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <Text
                                    strong
                                    style={{
                                      fontSize: "15px",
                                      lineHeight: "1.4",
                                    }}
                                  >
                                    {/* अगर आपके पास TruncateText है तो वो यूज़ करें, वरना CSS line-clamp */}
                                    <span
                                      style={{
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {data?.title}
                                    </span>
                                  </Text>
                                </div>

                                {/* 2. Price Section */}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "baseline",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <Title
                                    level={4}
                                    style={{
                                      margin: 0,
                                      color: isGramItem ? "#d48806" : "#000", // Gold color for Gold items
                                    }}
                                  >
                                    ₹
                                    {Math.round(productprice).toLocaleString(
                                      "en-IN",
                                    )}
                                  </Title>
                                  {isGramItem && (
                                    <Text
                                      type="secondary"
                                      style={{
                                        fontSize: "12px",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      (Est.)
                                    </Text>
                                  )}
                                </div>

                                {/* 3. Vendor / Seller Info */}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    borderTop: "1px solid #f0f0f0",
                                    paddingTop: "8px",
                                  }}
                                >
                                  <Link
                                    to={productUrl}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      color: "#8c8c8c",
                                      fontSize: "12px",
                                    }}
                                    // onClick={(e) => e.stopPropagation()} // Card click rokne ke liye
                                  >
                                    <ShopOutlined
                                      style={{ marginRight: "4px" }}
                                    />
                                    {data?.sellerId?.displayName || "Details"}
                                  </Link>

                                  {/* Arrow Icon for CTA */}
                                  <ArrowRightOutlined
                                    style={{
                                      fontSize: "12px",
                                      color: "#1890ff",
                                    }}
                                  />
                                </div>
                              </Card>
                            </Link>
                          </Col>
                        );
                      })}
                  </Row>
                </div>

              {/* <div class="col-md-12 col-12 p-8"></div>
              
              <div class="col-md-12 col-12 p-8"></div> */}
              {/* {get_product_list?.docs &&
                get_product_list?.docs?.map((data, i) => {
                  return (
                    i > 7 && (
                      <div class="col-md-3 col-4 p-8">
                        <div class="card subcategcard_back">
                          <Link to={"/product/" + data?.pro_sulg}>
                            <img
                              src={URL?.API_BASE_URL + data?.featureImage}
                              class="sub_cat_product_image"
                            />
                          </Link>
                          <h6 class="text-center bg-white">
                            {" "}
                            <TruncateText
                              text={data?.title}
                              maxLength={windowWidth > 600 ? 25 : 15}
                            />
                          </h6>
                        </div>
                      </div>
                    )
                  );
                })} */}

             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubCategoryProductAndCategory;
